
export enum SystemQuoteStatus {
    Open = 'Open',
    InProgress = 'In Progress',
    Closed = 'Closed',
    New = 'New',
    Allocated = 'Allocated',
    WaitingOnSupllier = 'Waiting on Supllier',
    Scoping = 'Scoping',
    AwaitingApproval = 'Awaiting Approval',
    Won = 'Won',
    Lost = 'Lost'
}
